export default "__VITE_ASSET__CJaqaP_X__"